import { request } from '@/shared/api/request'

export const getPhone = (params) => {
	return request({ url: '/user/getPhone', method: 'POST', params })
}
